var map = {
	"./App": 107,
	"./App.vue": 107,
	"./assets/chat_plus.jpg": 8168,
	"./assets/icons/bubble.webp": 967,
	"./assets/icons/heart.webp": 2310,
	"./assets/icons/network.webp": 5157,
	"./assets/img/b.webp": 8646,
	"./assets/profiles/profile_business.webp": 3969,
	"./assets/profiles/profile_family.webp": 9672,
	"./assets/profiles/profile_friend.webp": 472,
	"./assets/rot/stick1.webp": 4105,
	"./assets/rot/stick10.webp": 6741,
	"./assets/rot/stick11.webp": 416,
	"./assets/rot/stick12.webp": 1677,
	"./assets/rot/stick2.webp": 9209,
	"./assets/rot/stick3.webp": 8988,
	"./assets/rot/stick4.webp": 8379,
	"./assets/rot/stick5.webp": 2028,
	"./assets/rot/stick6.webp": 4031,
	"./assets/rot/stick7.webp": 6462,
	"./assets/rot/stick8.webp": 5743,
	"./assets/rot/stick9.webp": 5115,
	"./assets/screens/screen1.webp": 9124,
	"./assets/screens/screen2.webp": 381,
	"./assets/screens/screen3.webp": 6584,
	"./assets/screens/screen4.webp": 8117,
	"./assets/screens/screen5.webp": 66,
	"./assets/screens/screen6.webp": 3797,
	"./assets/screens/screen7.webp": 4702,
	"./assets/screens/shadow.webp": 7200,
	"./assets/stic_creator.webp": 3334,
	"./assets/stic_share.webp": 4809,
	"./assets/stickers/bear/1.webp": 5767,
	"./assets/stickers/bear/10.webp": 6117,
	"./assets/stickers/bear/11.webp": 7602,
	"./assets/stickers/bear/12.webp": 7071,
	"./assets/stickers/bear/13.webp": 3770,
	"./assets/stickers/bear/14.webp": 7047,
	"./assets/stickers/bear/15.webp": 9982,
	"./assets/stickers/bear/16.webp": 2703,
	"./assets/stickers/bear/17.webp": 4361,
	"./assets/stickers/bear/18.webp": 7290,
	"./assets/stickers/bear/19.webp": 9203,
	"./assets/stickers/bear/2.webp": 1832,
	"./assets/stickers/bear/20.webp": 8460,
	"./assets/stickers/bear/21.webp": 9219,
	"./assets/stickers/bear/22.webp": 4107,
	"./assets/stickers/bear/23.webp": 5031,
	"./assets/stickers/bear/24.webp": 8725,
	"./assets/stickers/bear/3.webp": 1894,
	"./assets/stickers/bear/4.webp": 7328,
	"./assets/stickers/bear/5.webp": 7752,
	"./assets/stickers/bear/6.webp": 5681,
	"./assets/stickers/bear/7.webp": 6699,
	"./assets/stickers/bear/8.webp": 5565,
	"./assets/stickers/bear/9.webp": 5350,
	"./assets/stickers/bear/main.png": 7188,
	"./assets/stickers/bear/tab.png": 8576,
	"./assets/stickers/bird/1.webp": 6370,
	"./assets/stickers/bird/10.webp": 4176,
	"./assets/stickers/bird/11.webp": 1906,
	"./assets/stickers/bird/12.webp": 9067,
	"./assets/stickers/bird/13.webp": 1295,
	"./assets/stickers/bird/14.webp": 3087,
	"./assets/stickers/bird/15.webp": 9767,
	"./assets/stickers/bird/16.webp": 3693,
	"./assets/stickers/bird/17.webp": 2864,
	"./assets/stickers/bird/18.webp": 6173,
	"./assets/stickers/bird/19.webp": 823,
	"./assets/stickers/bird/2.webp": 5683,
	"./assets/stickers/bird/20.webp": 6995,
	"./assets/stickers/bird/21.webp": 263,
	"./assets/stickers/bird/22.webp": 8234,
	"./assets/stickers/bird/23.webp": 3602,
	"./assets/stickers/bird/24.webp": 4201,
	"./assets/stickers/bird/3.webp": 8573,
	"./assets/stickers/bird/4.webp": 705,
	"./assets/stickers/bird/5.webp": 4421,
	"./assets/stickers/bird/6.webp": 3995,
	"./assets/stickers/bird/7.webp": 2732,
	"./assets/stickers/bird/8.webp": 1290,
	"./assets/stickers/bird/9.webp": 1814,
	"./assets/stickers/bird/main.png": 1037,
	"./assets/stickers/bird/tab.png": 3618,
	"./assets/stickers/business_1.webp": 4101,
	"./assets/stickers/business_2.webp": 2908,
	"./assets/stickers/friend_1.webp": 2178,
	"./assets/stickers/friend_2.webp": 6126,
	"./assets/stickers/mom_1.webp": 8654,
	"./assets/tabs/tab1.webp": 1423,
	"./assets/tabs/tab2.webp": 9061,
	"./components/ClipboardAlert": 8362,
	"./components/ClipboardAlert.vue": 8362,
	"./components/OrbitControls": 5408,
	"./components/OrbitControls.js": 5408,
	"./components/demo/Demo": 3566,
	"./components/demo/Demo.vue": 3566,
	"./components/demo/DemoChat": 8792,
	"./components/demo/DemoChat.new": 2760,
	"./components/demo/DemoChat.new.vue": 2760,
	"./components/demo/DemoChat.vue": 8792,
	"./components/demo/DemoChatItem": 8803,
	"./components/demo/DemoChatItem.vue": 8803,
	"./components/demo/DemoEmoji": 3901,
	"./components/demo/DemoEmoji.vue": 3901,
	"./components/demo/DemoHomeBar": 2487,
	"./components/demo/DemoHomeBar.vue": 2487,
	"./components/features/ChatExampleCard": 4485,
	"./components/features/ChatExampleCard.vue": 4485,
	"./components/features/ChatExampleMessageRow": 2555,
	"./components/features/ChatExampleMessageRow.vue": 2555,
	"./components/mast/MastHero": 6900,
	"./components/mast/MastHero.vue": 6900,
	"./components/nav/Navbar": 1324,
	"./components/nav/Navbar.vue": 1324,
	"./components/phone/Phone": 8274,
	"./components/phone/Phone.vue": 8274,
	"./components/section/SectionCont": 8101,
	"./components/section/SectionCont.vue": 8101,
	"./components/section/SectionDemo": 6124,
	"./components/section/SectionDemo.vue": 6124,
	"./components/section/SectionExclusive": 1098,
	"./components/section/SectionExclusive.vue": 1098,
	"./components/section/SectionFAQ": 2986,
	"./components/section/SectionFAQ.vue": 2986,
	"./components/section/SectionFeatures": 7940,
	"./components/section/SectionFeatures.vue": 7940,
	"./components/section/SectionFooter": 1984,
	"./components/section/SectionFooter.vue": 1984,
	"./components/section/SectionPhone": 7032,
	"./components/section/SectionPhone.vue": 7032,
	"./components/section/SectionShare": 6115,
	"./components/section/SectionShare.vue": 6115,
	"./components/section/SectionSummary": 3060,
	"./components/section/SectionSummary.vue": 3060,
	"./components/section/SectionTelecom": 1415,
	"./components/section/SectionTelecom.vue": 1415,
	"./components/stage/OrbitControl": 4565,
	"./components/stage/OrbitControl.js": 4565,
	"./components/stage/Stage": 8923,
	"./components/stage/Stage.vue": 8923,
	"./components/stage/StageScene": 8942,
	"./components/stage/StageScene.js": 8942,
	"./components/stage/utils": 1086,
	"./components/stage/utils.js": 1086,
	"./directives/scrollAnim": 8499,
	"./directives/scrollAnim.js": 8499,
	"./main": 866,
	"./main.js": 866,
	"./store": 4239,
	"./store/": 4239,
	"./store/index": 4239,
	"./store/index.js": 4239,
	"./styles/_main.import.scss": 8350,
	"./svg/svgChevronDown": 8439,
	"./svg/svgChevronDown.vue": 8439,
	"./svg/svgChevronUp": 6298,
	"./svg/svgChevronUp.vue": 6298,
	"./svg/svgHome": 8657,
	"./svg/svgHome.vue": 8657,
	"./svg/svgKT": 5763,
	"./svg/svgKT.vue": 5763,
	"./svg/svgLogo": 5085,
	"./svg/svgLogo.vue": 5085,
	"./svg/svgLogo3d": 6812,
	"./svg/svgLogo3d.vue": 6812,
	"./svg/svgLogoAltBig": 4244,
	"./svg/svgLogoAltBig.vue": 4244,
	"./svg/svgLogoBlack": 5995,
	"./svg/svgLogoBlack.vue": 5995,
	"./svg/svgLogoWhite": 2642,
	"./svg/svgLogoWhite.vue": 2642,
	"./svg/svgMail": 4156,
	"./svg/svgMail.vue": 4156,
	"./svg/svgOGQ": 2557,
	"./svg/svgOGQ.vue": 2557,
	"./svg/svgPlusPrimary": 4622,
	"./svg/svgPlusPrimary.vue": 4622,
	"./svg/svgProfile": 752,
	"./svg/svgProfile.vue": 752,
	"./svg/svgStatusBarIcons": 9502,
	"./svg/svgStatusBarIcons.vue": 9502,
	"./svg/svgTworld": 5323,
	"./svg/svgTworld.vue": 5323,
	"./svg/svgUPlus": 547,
	"./svg/svgUPlus.vue": 547,
	"./svg/svgWatermarkLogo": 8083,
	"./svg/svgWatermarkLogo.vue": 8083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;